<template>
    <div class="valuation-vehicle-details">
        <div v-if="displayImage" class="valuation-vehicle-details__car-image-container">
            <div class="valuation-vehicle-details__img-area">
                <img class="img-responsive valuation-vehicle-details__starburst" src="/images/configurator/stellantis-starburst.svg" alt="Stellantis Starburst">
                <img v-if="displayImage" class="valuation-vehicle-details__vehicle" :class="{ 'valuation-vehicle-details__not-found-image': hasUkVehicleData === false }" :src="vehicleImage" alt="Car Image" />
                <p v-if="hasUkVehicleData" :class="{ 'valuation-vehicle-details__illustrative-message--imagin-studio': imaginStudioImage }" class="valuation-vehicle-details__illustrative-message">Image for illustrative purposes only</p>
            </div>
        </div>

        <div v-if="vehicleDetails" class="valuation-vehicle-details__blue-box">
            <h3 class="valuation-vehicle-details__title">Your Vehicle Details</h3>
            <div class="valuation-vehicle-details__row" v-if="vehicleDetails.customer_name && vehicleDetails.customer_name !== ''">
                <span class="valuation-vehicle-details__label">Name:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.customer_name }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Make:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.make }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Model:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.model }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Bodystyle:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.body_type }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Derivative:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.derivative }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Engine size:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.engine_size }} cc</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Fuel type:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.fuel_type }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Transmission:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.transmission }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Registration date:</span>
                <span class="valuation-vehicle-details__value">{{ vehicleDetails.first_registered }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Mileage entered:</span>
                <span class="valuation-vehicle-details__value">{{ mileage }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Registration:</span>
                <span class="valuation-vehicle-details__value">{{ registration }}</span>
            </div>
        </div>
        <div v-else-if="nonFranchiseVehicle" class="valuation-vehicle-details__blue-box">
            <h3 class="title">Your vehicle details</h3>
            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Make:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.make }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Model:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.model }}</span>
            </div>

            <div class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Description:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.variant }}</span>
            </div>

            <div v-if="nonFranchiseVehicle.extraInfo" class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Anything else:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.extraInfo }}</span>
            </div>

            <div v-if="nonFranchiseVehicle.reg_no" class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Registration:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.reg_no }}</span>
            </div>

            <div v-if="nonFranchiseVehicle.mileage" class="valuation-vehicle-details__row">
                <span class="valuation-vehicle-details__label">Mileage:</span>
                <span class="valuation-vehicle-details__value">{{ nonFranchiseVehicle.mileage }}</span>
            </div>
        </div>
    </div>


</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
    props: {
        displayImage: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapState('ValuationTool', ['step', 'selectedVehicle', 'registration', 'mileage', 'nonFranchiseVehicle', 'otherSelected', 'hasUkVehicleData']),
        ...mapGetters('ValuationTool', ['vehicleImage']),

        imaginStudioImage() {
            return String(this.vehicleImage).substring(0, 25) == 'https://cdn.imagin.studio';
        },

        vehicleDetails() {
            return this.selectedVehicle;
        }
    }
}
</script>
